import { SetupByKeyFetch } from "@/api/setup";
import { useJourneyUuid } from '@/hooks/useJourneyUuid/useJourneyUuid';
import { useConfigStore } from "@/store/config";
import { useEffect } from "react";

export function Loader() {
  useJourneyUuid();
  
  const setShortFlowOn = useConfigStore((store) => store.setShortFlowOn);
  const { data: ShortFlowOnData } = SetupByKeyFetch("SF_ON");
  useEffect(() => {
    if (ShortFlowOnData?.valor) {
      setShortFlowOn(ShortFlowOnData.valor === "true");
    }
  }, [ShortFlowOnData, setShortFlowOn]);

  const setVariantSpeedFlow = useConfigStore(
    (store) => store.setVariantSpeedFlow
  );
  const { data: MediumShortFlowData } = SetupByKeyFetch("ALLOWED_MEDIUMS");
  useEffect(() => {
    if (MediumShortFlowData?.valor) {
      setVariantSpeedFlow(MediumShortFlowData?.valor?.split?.(",") || ["off"]);
    }
  }, [MediumShortFlowData, setVariantSpeedFlow]);

  return null;
}
